import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import useSearch from 'hooks/useSearch';
import React, { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SimpleSearchInput from 'components/SearchInputNavbar';

const CustomerHistory = () => {
  const { setComponent } = useTopPanel();
  const { id } = useParams();
  const query = useSearch();
  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setComponent(
      <div className='component-title'>
        Yetkazib beruvchi tarixi:{' '}
        {query.get('customerName') ? query.get('customerName') : ''}
      </div>
    );
  }, [query.get('customerName')]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex items-center justify-center gap-2'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath={`admin/partners/history/${id}`}
          emitTableColumns={{ open, setOpen }}
          tableName='admin/partners/history/'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'date', label: 'Sana' },
            { code: 'inputsum', label: 'Kirim' },
            { code: 'inputval', label: '' },
            { code: 'outputsum', label: 'Chiqim' },
            { code: 'outputval', label: '' },
            { code: 'debtsum', label: 'Qarzdorlik' },
            { code: 'debtval', label: '' },
            { code: 'typename', label: 'Turi' },
            { code: 'comment', label: 'Izohi' },
            { code: 'staff', label: "Mas'ul xodim" },
          ]}
          columns={[
            { code: 'id' },
            { code: 'date', type: 'date' },
            { code: 'inputsum', type: 'priceSum' },
            { code: 'inputval', type: 'price' },
            { code: 'outputsum', type: 'priceSum' },
            { code: 'outputval', type: 'price' },
            { code: 'debtsum', type: 'priceSum' },
            { code: 'debtval', type: 'price' },
            { code: 'typename' },
            { code: 'comment' },
            { code: 'staff', type: 'nested', childStr: 'name' },
          ]}
          withPageSize
          noActions
        />
      </div>
    </div>
  );
};

export default memo(CustomerHistory);
